<app-mobile-page-shell [hideBottomNav]="true">

  <!-- ===== OVERVIEW VIEW ===== -->
  <ng-container *ngIf="activeView === 'overview'">
    <div class="m-dash-mobile-content">

      <!-- Budgeted card -->
      <div class="m-dash-overview-card m-dash-overview-card--inventory mx-3 mt-3">
        <div class="m-dash-overview-header">
          <div class="m-dash-overview-icon m-dash-overview-icon--inventory">
            <i class="bi bi-wallet2"></i>
          </div>
          <div>
            <h6 class="m-dash-overview-title mb-0">Budgeted</h6>
            <small class="text-muted">Total planned spend</small>
          </div>
        </div>
        <div class="m-dash-overview-row">
          <div class="m-dash-overview-item">
            <span class="m-dash-overview-label">Total Budget</span>
            <span class="m-dash-overview-value">{{ totalBudgetAmount | currency:'ZAR':'symbol':'1.2-2' }}</span>
          </div>
        </div>
      </div>

      <!-- Actual card -->
      <div class="m-dash-overview-card m-dash-overview-card--overheads mx-3 mt-3">
        <div class="m-dash-overview-header">
          <div class="m-dash-overview-icon m-dash-overview-icon--overheads">
            <i class="bi bi-cash-coin"></i>
          </div>
          <div>
            <h6 class="m-dash-overview-title mb-0">Actual</h6>
            <small class="text-muted">Total recorded spend</small>
          </div>
        </div>
        <div class="m-dash-overview-row">
          <div class="m-dash-overview-item">
            <span class="m-dash-overview-label">Total Actual</span>
            <span class="m-dash-overview-value">{{ totalActualAmount | currency:'ZAR':'symbol':'1.2-2' }}</span>
          </div>
        </div>
      </div>

      <!-- Variance card -->
      <div class="m-dash-overview-card m-dash-overview-card--orders mx-3 mt-3 mb-3">
        <div class="m-dash-overview-header">
          <div class="m-dash-overview-icon m-dash-overview-icon--orders">
            <i class="bi bi-graph-up-arrow"></i>
          </div>
          <div>
            <h6 class="m-dash-overview-title mb-0">Variance</h6>
            <small class="text-muted">Budget minus actual</small>
          </div>
        </div>
        <div class="m-dash-overview-row">
          <div class="m-dash-overview-item">
            <span class="m-dash-overview-label">Variance</span>
            <span class="m-dash-overview-value"
              [class.text-success]="varianceAmount >= 0"
              [class.text-danger]="varianceAmount < 0">
              {{ varianceAmount | currency:'ZAR':'symbol':'1.2-2' }}
            </span>
          </div>
        </div>
      </div>

    </div>
  </ng-container>

  <!-- ===== BUDGETS VIEW ===== -->
  <ng-container *ngIf="activeView === 'budgets'">

    <!-- Metric Ribbon -->
    <div class="m-dash-tab-ribbon">
      <app-mobile-metric-ribbon [metrics]="ribbonMetrics"></app-mobile-metric-ribbon>
    </div>

    <div class="m-section m-section--budgets">

      <!-- Row 1: header -->
      <div class="m-section-header">
        <div class="m-section-icon"><i class="bi bi-clipboard-data"></i></div>
        <div class="m-section-header-text">
          <h6 class="m-section-title mb-0">
            {{ activeInnerTab === 'chart' ? 'Budget vs Actual' : 'Budget & Variance' }}
          </h6>
        </div>
        <button class="btn btn-outline-primary btn-sm ms-auto" (click)="openAdd()">
          <i class="bi bi-plus-lg me-1"></i>Add
        </button>
        <button class="m-cfg-filter-toggle ms-2"
          [class.active]="budgetFiltersOpen || activeFilterCount > 0"
          (click)="toggleBudgetFilters()">
          <i class="bi bi-funnel"></i>
          <span *ngIf="activeFilterCount > 0" class="m-cfg-filter-badge">{{ activeFilterCount }}</span>
        </button>
      </div>

      <!-- Collapsible filter panel -->
      <div class="m-cfg-filter-panel mb-3" *ngIf="budgetFiltersOpen">
        <div class="m-filter-group">
          <label class="m-filter-label">Budget Type</label>
          <app-single-select-dropdown
            [options]="budgetTypeOptions"
            placeholder="Budget Type"
            [selectedValue]="selectedBudgetType"
            (selectedValueChange)="onTypeDropdown($event)">
          </app-single-select-dropdown>
        </div>

        <div class="m-filter-group"
             *ngIf="selectedBudgetType === 'monthly' || selectedBudgetType === 'quarterly' || selectedBudgetType === 'annually'">
          <label class="m-filter-label">Date Range</label>
          <div class="date-range-grid" [class.single]="selectedBudgetType === 'annually'">

            <app-single-select-dropdown *ngIf="selectedBudgetType === 'monthly'"
              [options]="monthOptions"
              placeholder="Month"
              [selectedValue]="String(selectedMonth)"
              (selectedValueChange)="onMonthDropdown($event)">
            </app-single-select-dropdown>

            <app-single-select-dropdown *ngIf="selectedBudgetType === 'quarterly'"
              [options]="quarterOptions"
              placeholder="Quarter"
              [selectedValue]="String(selectedQuarter)"
              (selectedValueChange)="onQuarterDropdown($event)">
            </app-single-select-dropdown>

            <app-single-select-dropdown
              [options]="yearOptions"
              placeholder="Year"
              [selectedValue]="String(selectedYear)"
              (selectedValueChange)="onYearDropdown($event)">
            </app-single-select-dropdown>
          </div>
        </div>
      </div>

      <!-- Row 2: Chart | Records segmented toggle -->
      <div class="m-inner-tabs">
        <button [class.active]="activeInnerTab === 'records'" (click)="setInnerTab('records')">
          <i class="bi bi-clipboard-data me-1"></i>Records
        </button>
         <button [class.active]="activeInnerTab === 'chart'" (click)="setInnerTab('chart')">
          <i class="bi bi-bar-chart me-1"></i>Chart
        </button>
      </div>

      <!-- Chart content -->
      <ng-container *ngIf="activeInnerTab === 'chart'">
        <div class="m-chart-pager-strip">
          <div class="m-chart-pager">
            <button class="m-pager-btn" [disabled]="currentPage <= 1" (click)="prevPage.emit()">
              <i class="bi bi-chevron-left"></i>
            </button>
            <span class="m-pager-label">{{ currentPage }} / {{ totalPages }}</span>
            <button class="m-pager-btn" [disabled]="currentPage >= totalPages" (click)="nextPage.emit()">
              <i class="bi bi-chevron-right"></i>
            </button>
          </div>
        </div>
        <div class="m-chart-canvas" *ngIf="budgetVsActualChartData.labels && budgetVsActualChartData.labels.length > 0">
          <canvas baseChart
            [data]="budgetVsActualChartData"
            [options]="mobileChartOptions"
            [type]="'bar'">
          </canvas>
        </div>
        <div *ngIf="!budgetVsActualChartData.labels || budgetVsActualChartData.labels.length === 0" class="m-empty">
          <i class="bi bi-bar-chart"></i>
          <p>No chart data for this filter</p>
        </div>
      </ng-container>

      <!-- Records content -->
      <ng-container *ngIf="activeInnerTab === 'records'">
        <div *ngIf="isLoading" class="m-loading">
          <div class="spinner-border spinner-border-sm text-secondary" role="status"></div>
          <span>Loading budgets…</span>
        </div>

        <div *ngIf="!isLoading && filteredBudgets.length === 0" class="m-empty">
          <i class="bi bi-clipboard-x"></i>
          <p>No budgets for this filter</p>
        </div>

        <div class="m-cards-section">
          <app-mobile-data-card
            *ngFor="let budget of filteredBudgets; let i = index"
            [title]="budget.budgetName"
            [primaryValue]="formatCurrency(calcPlanned(budget))"
            [badgeLabel]="budget.budgetType"
            [fields]="cardFields(budget)"
            [animationDelay]="i * 50"
            [fullItem]="budget"
            (cardTap)="openEdit($event)"
            (editTap)="openEdit($event)"
            (deleteTap)="openDeleteSheet($event)">
          </app-mobile-data-card>
        </div>
      </ng-container>

    </div>

  </ng-container>

  <!-- ===== AI INSIGHTS VIEW ===== -->
  <ng-container *ngIf="activeView === 'ai'">
    <div class="m-ai-wrapper">
      <app-aivor-insights
        [filterStart]="dateRange.start"
        [filterEnd]="dateRange.end"
        [selectedBudgetType]="selectedBudgetType">
      </app-aivor-insights>
    </div>
  </ng-container>

</app-mobile-page-shell>

<!-- ===== Add/Edit Budget Offcanvas ===== -->
<app-budget-item-offcanvas
  [visible]="offcanvasVisible"
  [budget]="offcanvasBudget"
  [isEditing]="offcanvasEditing"
  [fiscalPeriods]="fiscalPeriods"
  [months]="monthOptions"
  [quarters]="quarterOptions"
  [years]="yearOptions"
  (closeCanvas)="onOffcanvasClose()"
  (save)="onOffcanvasSave($event)">
</app-budget-item-offcanvas>

<!-- ===== Delete Confirmation Sheet ===== -->
<div class="m-del-overlay" *ngIf="deleteSheetVisible || deleteSheetClosing"
  [style.opacity]="deleteSheetClosing ? 0 : (mobileDeleteSwipeActive ? (1 - mobileDeleteSwipeProgress * 0.6) : null)"
  [style.transition]="deleteSheetClosing ? 'opacity 0.28s ease' : null"
  (click)="$event.target === $event.currentTarget && closeDeleteSheet()">
  <div class="m-del-sheet" (click)="$event.stopPropagation()"
    [style.transform]="deleteSheetClosing ? 'translateY(100%)' : (mobileDeleteSwipeDeltaY ? 'translateY(' + mobileDeleteSwipeDeltaY + 'px)' : null)"
    [style.transition]="deleteSheetClosing ? 'transform 0.3s cubic-bezier(0.4,0,0.2,1)' : (mobileDeleteSwipeActive ? 'none' : 'transform 0.3s cubic-bezier(0.4,0,0.2,1)')">
    <div class="m-del-handle-bar"
      (touchstart)="onDeleteSheetTouchStart($event)"
      (touchmove)="onDeleteSheetTouchMove($event)"
      (touchend)="onDeleteSheetTouchEnd()">
      <div class="m-del-handle"
        [style.width.px]="36 + mobileDeleteSwipeProgress * 20"
        [style.background]="'rgb(' + Math.round(222 + mobileDeleteSwipeProgress * -222) + ',' + Math.round(226 + mobileDeleteSwipeProgress * (122 - 226)) + ',' + Math.round(230 + mobileDeleteSwipeProgress * (143 - 230)) + ')'">
      </div>
    </div>
    <div class="m-del-header">
      <h5 class="m-del-title">Delete Budget</h5>
      <button class="m-del-close-btn" (click)="closeDeleteSheet()"><i class="bi bi-x-lg"></i></button>
    </div>
    <div class="m-del-body">
      <p class="m-del-text">Are you sure you want to <strong class="text-danger">delete</strong> the budget <strong>{{ budgetToDelete?.budgetName }}</strong>? This action cannot be undone.</p>
    </div>
    <div class="m-del-footer">
      <button class="btn m-del-btn-cancel flex-fill" (click)="closeDeleteSheet()">Cancel</button>
      <button class="btn m-del-btn-confirm flex-fill" (click)="confirmDelete()">Delete</button>
    </div>
  </div>
</div>
